import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService, JhiLanguageService } from 'ng-jhipster';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';

import { Principal } from '../auth/principal.service';
import { AuthServerProvider } from '../auth/auth-jwt.service';
import { UtilsService } from '../utils/utils.service';
import { PropertiesService } from '../../entities/saisine/properties.service';

@Injectable()
export class LoginService {
    internalLogin: boolean;

    constructor(
        private languageService: JhiLanguageService,
        private principal: Principal,
        private authServerProvider: AuthServerProvider,
        private utilsService: UtilsService,
        private router: Router,
        private idle: Idle,
        private alertService: AlertService,
        private propertiesService: PropertiesService
    ) {
        this.internalLogin = false;
    }

    login(credentials, callback?) {
        let cb = callback || function () { };

        this.closeAllAlertByDisconnection();
        return new Promise((resolve, reject) => {
            this.authServerProvider.login(credentials).subscribe(data => {
                this.principal.identity(true).then(account => {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account !== null) {
                        this.utilsService.deleteBckgrnd();
                        this.languageService.changeLanguage(account.langKey);
                        this.internalLogin = false;
                        this.getDisconnectedTime();
                    }
                    resolve(data);
                });
                return cb();
            }, err => {
                this.logout();
                reject(err);
                return cb(err);
            });
        });
    }

    loginInternal(credentials, callback?) {
        let cb = callback || function () { };

        this.closeAllAlertByDisconnection();
        return new Promise((resolve, reject) => {
            this.authServerProvider.loginInternal(credentials).subscribe(data => {
                this.principal.identity(true).then(account => {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account !== null) {
                        this.utilsService.deleteBckgrnd();
                        this.languageService.changeLanguage(account.langKey);
                        this.internalLogin = true;
                        this.getDisconnectedTime();
                    }
                    resolve(data);
                });
                return cb();
            }, err => {
                this.logout();
                reject(err);
                return cb(err);
            });
        });
    }

    loginWithToken(jwt, rememberMe) {
        return this.authServerProvider.loginWithToken(jwt, rememberMe);
    }

    logoutAndRedirect() {
        this.logout();
        this.closeAllAlertByDisconnection();
        this.alertService.get().push(this.alertService.addAlert({
            type: 'danger',
            msg: 'global.menu.account.disconnected',
            timeout: 0,
            scoped: true,
            toast: this.alertService.isToast()
        },
            this.alertService.get()
        ));
        if (this.internalLogin) {
            this.router.navigate(['/interne']);
        } else {
            this.router.navigate(['/']);
        }
    }

    closeAllAlertByDisconnection() {
        this.alertService.clear();
    }

    logout() {
        this.idle.stop();
        this.utilsService.setBckgrnd();
        this.authServerProvider.logout().subscribe();
        this.principal.authenticate(null);
    }

    getDisconnectedTime(): void {
        // sets a timeout period of 15 mn
        let time: number;
        if (!this.internalLogin) {
            time = Number(this.propertiesService.properties.disconnectedTimeStudent);
        } else {
            time = Number(this.propertiesService.properties.disconnectedTimeInternal);
        }
        this.idle.setIdle(1);
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
        this.idle.setTimeout(time);
        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        this.idle.onTimeout.subscribe(() => {
            this.logoutAndRedirect();
        });
        this.idle.watch();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/login/login.service.ts